<template>
  <!-- <GlobalLoader /> -->
  <notifications />
  <router-view />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import GlobalLoader from '@/components/GlobalLoader.vue';

export default defineComponent({
  name: 'App',
  components: {
    GlobalLoader,
  },
});
</script>
